import React from 'react';
import styles from './SectionReview.module.css';

const testimonialsData = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'Local Quality Honey',
    quote: 'I absolutely love the quality of products on this platform!',
    image: 'https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael Davis',
    role: 'Loyal Customers',
    quote: 'Great finds amazing! I find professional services all the time.',
    image: 'https://t4.ftcdn.net/jpg/04/31/64/75/360_F_431647519_usrbQ8Z983hTYe8zgA7t1XVc5fEtqcpa.jpg',
    rating: 5,
  },
  {
    id: 3,
    name: 'Jennifer Smith',
    role: 'Happy Customers',
    quote: 'Friendly service and exceptional quality every single time.',
    image: 'https://media.easy-peasy.ai/4b1cd954-9633-4c43-858e-11c91db2961e/ff4612dc-9731-4a47-a42c-759dbc51081e_medium.webp',
    rating: 5,
  },
];

const SectionReview = () => {
  const renderStars = rating => {
    return '★'.repeat(rating);
  };

  return (
    <section className={styles.testimonialSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>What Neighbors Are Saying</h2>

        <div className={styles.testimonialsGrid}>
          {testimonialsData.map(testimonial => (
            <div key={testimonial.id} className={styles.testimonialCard}>
             
              
               
              <div className={styles.author}>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className={styles.authorImage}
                />
                <div className={styles.authorInfo}>
                   <p className={styles.quote}>&quot;{testimonial.quote}&quot;</p>
                  <p className={styles.authorName}>{testimonial.name}</p>
                  <p className={styles.authorRole}>{testimonial.role}</p>
                  <div className={styles.rating}>
                <span className={styles.stars}>{renderStars(testimonial.rating)}</span>
              </div>
                </div>
                
              </div>
               
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default SectionReview;
